/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React from 'react';
import { AppConsumer, util } from '@keystone/common';
import { Header } from '@scuf/common';
import { withRouter } from 'react-router-dom';
import Routes from '../common/routes';

const UserDropdown = (props) => (
  <AppConsumer>
    {(appContext) => {
      if (appContext.user) {
        return (
          <Header.UserProfile
            firstName={appContext.user.firstName}
            lastName={appContext.user.lastName}
          >
            <Header.UserProfile.Item
              onClick={() => {
                props.history.push(Routes.UserPreferences);
              }}
            >
              User Preferences
            </Header.UserProfile.Item>
            <Header.UserProfile.Item onClick={appContext.logout}>Sign Out</Header.UserProfile.Item>
            {util.getSentienceEnableFlag() === true ? (
              ''
            ) : (
              <Header.UserProfile.Item onClick={props.handleChangePassword}>
                Change Password
              </Header.UserProfile.Item>
            )}
          </Header.UserProfile>
        );
      }
      return null;
    }}
  </AppConsumer>
);

export default withRouter(UserDropdown);
